import React from "react";
import "./MainHerosection.css";
import herocrm from "../assetsprogressive/herocrm.png";
const MainHerosection = () => {
  return (
    <div  id="heromain">
    <div className="progressive-wrapper">
          <div className="main-container">
        <div className="crmherocontent">
          <h1 className="heroHeading">
            <span>Custom CRM</span> Development Company
          </h1>
          <h4 className="heroh4">
            Get Any CRM Functionality For Smarter Customer Management
          </h4>
          <p className="subHeading">
            BastionEx CRM development services empower businesses to automate
            workflows, boost productivity, and deliver exceptional customer
            experiences. We build scalable, user-friendly CRM solutions tailored
            to your growth goals.
          </p>
        </div>
        <img src={herocrm} alt="error" className="main-img" />
      </div>
    </div>
    </div>
  );
};

export default MainHerosection;
